/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import * as Styled from "../../styles";
import Button from "@components/common/Button";
import type {
  IAccountsComponents,
  ValuesFormikAccountPhysical,
} from "src/@types/Sales";
import { useFormik } from "formik";
import { isEmail } from "@helpers/emailCheck";
import { LoginContext } from "@context/loginContext";
import enterprisesServiceInstance from "@services/Enterprises/enterprisesService";
import Alert from "@components/common/Alert";
import salesService from "@services/Sales/SalesService";
import Spinner from "@components/common/Spinner";
import { UsuallyContext } from "@context/usuallyContex";
import { SectionMainInformations } from "../../components/SectionPhysical/SectionMainInformationsComponent";
import { SectionProductsInterest } from "../../components/SectionProductsInterestComponent";
import { phoneMask } from "@helpers/format";
import { useMessageErrorToast } from "@hook/useMessageErrorToast";
import { format, parse } from "date-fns";
import oportunityServiceInstance from "@services/Oportunity/OportunityService";
import { useOnlyMessageToast } from "@hook/useMessageToast";
import { OportunityContext } from "@context/oportunityContex";
import { useNavigate } from "react-router-dom";

const AccountsPhysicalComponents = () => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate("/oportunidades");
  }, [navigate]);

  return (
    <AccountsPhysicalComponentsOriginal
      onBack={handleBack}
      setMandatoryCreateAccount={() => {}}
      setCnpjCreateAccount={() => {}}
      setCpfCreateAccount={() => {}}
    />
  );
};

export const AccountsPhysicalComponentsOriginal = React.memo(
  ({
    onBack,
    isCreateAccount,
    setCpfCreateAccount,
    setMandatoryCreateAccount,
  }: IAccountsComponents) => {
    const idCorretor = useRef<string>(
      localStorage.getItem("@idCorretor") ?? "",
    );
    const regionalUser = useRef<string>(
      localStorage.getItem("@regional") ?? "",
    );
    const regional = regionalUser.current;

    const displayMessage = useOnlyMessageToast();
    const displayMessageError = useMessageErrorToast();
    const { signOut } = React.useContext(LoginContext);
    const { setIndexTabDetails } = React.useContext(OportunityContext);
    const {
      setSuccessCreateAccountSales,
      setNameCreateAccountSales,
      setAccountIdSalesforce,
      setTypeAccount,
    } = React.useContext(UsuallyContext);

    const [isUnauthorized, setIsUnauthorized] = useState(false);
    const [treatment, setTreatment] = useState("");
    const [commercialRegional, setCommercialRegional] = useState("");
    const [businessUnity, setBusinessUnity] = useState("");
    const [selectedValues, setSelectedValues] = useState<string[]>([]);
    const [income, setIncome] = useState("");
    const [bestHours, setBestHours] = useState("");
    const [purposePurchase, setPurposePurchase] = useState("");
    const [detailsLive, setDetailsLive] = useState("");
    const [numberKids, setNumberKids] = useState("");
    const [numberRooms, setNumberRooms] = useState("");
    const [numberVacancy, setNumberVacancy] = useState("");
    const [typeWork, setTypeWork] = useState("");
    const [require, setRequire] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingEnterprises, setLoadingEnterprises] = useState(false);
    const [dataEnterprises, setDataEnterprises] = useState([]);

    const [selectProfession, setSelectProfession] = useState("");
    const [loadingProfession, setLoadingProfession] = useState(false);
    const [dataProfession, setDataProfession] = useState([]);
    const [idProfession, setIdProfession] = useState("");

    const [loadingCampaign, setLoadingCampaign] = useState(false);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [idEnterprises, setIdEnterprises] = useState("");
    const [idCampaign, setIdCampaign] = useState("");
    const [error, setError] = useState({
      email: false,
      telefone: false,
      cpf: false,
    });
    const [campaign, setCampaign] = useState("");
    const [selectCampaign, setSelectCampaign] = useState("");
    const [mainEnterprises, setMainEnterprises] = useState("");
    const [selectMainEnterprises, setSelectMainEnterprises] = useState("");
    const [originAccount, setOriginAccount] = useState("");

    const [dateIssue, setDateIssue] = React.useState("");
    const [dateBirth, setDateBirth] = React.useState("");
    const [nationality, setNationality] = React.useState("");
    const [profession, setProfession] = React.useState("");
    const [civilStatus, setCivilStatus] = React.useState("");
    const [sex, setSex] = React.useState("");
    const [weddingDate, setWeddingDate] = React.useState("");
    const [marriageRegime, setMarriageRegime] = React.useState("");

    // useMemo: recalcula apenas quando selectedValues muda, evitando múltiplos .includes() em cada render
    const {
      isWhatsAppComplementary,
      isCelularComplementary,
      isWhatsAppPrincipal,
      isCelularPrincipal,
    } = useMemo(
      () => ({
        isWhatsAppComplementary: selectedValues.includes(
          "WhatsappComplementary",
        ),
        isCelularComplementary: selectedValues.includes("CelularComplementary"),
        isWhatsAppPrincipal: selectedValues.includes("Whatsapp"),
        isCelularPrincipal: selectedValues.includes("Celular"),
      }),
      [selectedValues],
    );

    const initialValues = useMemo(
      () => ({
        nameAccount: "",
        mainPhone: "",
        mainEmail: "",
        complementaryPhone: "",
        complementaryEmail: "",
        comments: "",
        cpf: "",
        rg: "",
        orgaoExpedidorRG: "",
      }),
      [],
    );

    const handleDateFormat = useCallback((date: string) => {
      if (!date) return null;
      const parsedDate = parse(date, "yyyy-MM-dd", new Date());
      return format(parsedDate, "yyyy-MM-dd'T'00:00:00'Z'");
    }, []);

    const handleSubmitFormik = useCallback(
      async (value: ValuesFormikAccountPhysical) => {
        setLoading(true);
        setMandatoryCreateAccount(false);

        const bodyIsCreateAccount = {
          idCorretorSalesforce: idCorretor.current,
          tipoRegistro: "Cliente - Pessoa Física",
          nomeDaConta: value?.nameAccount,
          regional,
          regionalComercial: commercialRegional,
          telefonePrincipal: phoneMask(value?.mainPhone),
          emailPrincipal: value?.mainEmail,
          unidadeDeNegocio: businessUnity,
          telefoneComplementarEhWhatsapp: isWhatsAppComplementary,
          telefoneComplementarEhCelular: isCelularComplementary,
          telefonePrincipalEhWhatsapp: isWhatsAppPrincipal,
          telefonePrincipalEhCelular: isCelularPrincipal,
          cpf: value?.cpf,
          rg: value?.rg,
          estadoCivil: civilStatus,
          nacionalidade: nationality,
          profissao: profession,
          orgaoExpedidorRG: value?.orgaoExpedidorRG,
          dataExpedicaoRG: handleDateFormat(dateIssue),
          dataNascimento: handleDateFormat(dateBirth),
          criarOportunidade: isCreateAccount ? false : true,
          sexo: sex,
          dataCasamento: handleDateFormat(weddingDate),
          regimeCasamento: marriageRegime,
        };

        const body = {
          idCorretorSalesforce: idCorretor.current,
          tipoRegistro: "Cliente - Pessoa Física",
          origemDaConta: originAccount,
          tratamento: treatment,
          nomeDaConta: value?.nameAccount,
          regional,
          regionalComercial: commercialRegional,
          telefonePrincipal: phoneMask(value?.mainPhone),
          emailPrincipal: value?.mainEmail,
          unidadeDeNegocio: businessUnity,
          renda: income,
          telefoneComplementar: phoneMask(value?.complementaryPhone),
          emailComplementar: value?.complementaryEmail,
          campanha: idCampaign,
          melhorHorarioDeAtendimento: bestHours,
          finalidadeDaCompra: purposePurchase,
          detalhesPodeMorar: detailsLive,
          tipoDeTrabalho: typeWork,
          numeroDeFilhos: numberKids,
          observacoes: value.comments,
          telefoneComplementarEhWhatsapp: isWhatsAppComplementary,
          telefoneComplementarEhCelular: isCelularComplementary,
          telefonePrincipalEhWhatsapp: isWhatsAppPrincipal,
          telefonePrincipalEhCelular: isCelularPrincipal,
          empreendimentoDeInteressePrincipal: idEnterprises,
          numeroDeQuartos: numberRooms,
          numeroDeVagas: numberVacancy,
          cpf: value?.cpf,
          rg: value?.rg,
          estadoCivil: civilStatus,
          nacionalidade: nationality,
          profissao: profession,
          orgaoExpedidorRG: value?.orgaoExpedidorRG,
          dataExpedicaoRG: handleDateFormat(dateIssue),
          dataNascimento: handleDateFormat(dateBirth),
          criarOportunidade: isCreateAccount ? false : true,
          sexo: sex,
          dataCasamento: handleDateFormat(weddingDate),
          regimeCasamento: marriageRegime,
        };

        try {
          const response = await salesService.createPersonPhisycal(
            isCreateAccount ? bodyIsCreateAccount : body,
          );

          if (
            response?.status === 400 &&
            (response?.data?.emailJaUtilizado ||
              response?.data?.telefoneJaUtilizado ||
              response?.data?.cpfCnpjJaUtilizado)
          ) {
            setError((prevState) => ({
              ...prevState,
              email: response?.data?.emailJaUtilizado,
              telefone: response?.data?.telefoneJaUtilizado,
              cpf: response?.data.cpfCnpjJaUtilizado,
            }));
            setLoading(false);
            const messageErro = response?.data?.erro;
            displayMessageError({
              message: messageErro ?? "Erro ao criar conta!",
            });
            return;
          }

          if (response?.status === 400) {
            const messageErro = response?.data;
            setLoading(false);
            displayMessageError({
              message: messageErro ?? "Erro ao criar conta!",
            });
            return;
          }

          if (response?.status === 401) {
            setLoading(false);
            setIsUnauthorized(true);
            return;
          }

          if (isCreateAccount) {
            onBack();
            displayMessage("Conta criada com sucesso!");
            setCpfCreateAccount(value?.cpf);
            setMandatoryCreateAccount(true);
          } else {
            setSuccessCreateAccountSales(true);
            setNameCreateAccountSales(value?.nameAccount);
            setAccountIdSalesforce(response?.data.id);
          }

          setIndexTabDetails(0);
          setTypeAccount("");
          setLoading(false);
        } catch (error) {
          console.log("ErrorFormik", error);
          setLoading(false);
        }
      },
      [
        regional,
        commercialRegional,
        businessUnity,
        isWhatsAppComplementary,
        isCelularComplementary,
        isWhatsAppPrincipal,
        isCelularPrincipal,
        civilStatus,
        nationality,
        profession,
        dateIssue,
        dateBirth,
        sex,
        weddingDate,
        marriageRegime,
        originAccount,
        treatment,
        income,
        idCampaign,
        bestHours,
        purposePurchase,
        detailsLive,
        typeWork,
        numberKids,
        idEnterprises,
        numberRooms,
        numberVacancy,
        isCreateAccount,
        handleDateFormat,
        onBack,
        displayMessage,
        displayMessageError,
        setCpfCreateAccount,
        setMandatoryCreateAccount,
        setSuccessCreateAccountSales,
        setNameCreateAccountSales,
        setAccountIdSalesforce,
        setIndexTabDetails,
        setTypeAccount,
      ],
    );

    const formik: any = useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: handleSubmitFormik,
    });

    const handleGetEnterprises = useCallback(async () => {
      setLoadingEnterprises(true);
      try {
        const response = await enterprisesServiceInstance.getEnterprises({
          regional: regionalUser.current,
        });

        if (response.status >= 400 && response?.status !== 401) {
          setLoadingEnterprises(false);
          setDataEnterprises([]);
          console.log("status 400", response);
          return;
        }
        if (response.status === 401) {
          setLoadingEnterprises(false);
          setIsUnauthorized(true);
          setDataEnterprises([]);
          return;
        }

        const dataArray: any = Object.values(response);
        setDataEnterprises(dataArray);
        setLoadingEnterprises(false);
      } catch (error) {
        setLoadingEnterprises(false);
        console.log("errorHandleGetEnterprises", error);
      }
    }, []);

    const handleGetCampaign = useCallback(async () => {
      setLoadingCampaign(true);
      try {
        const response = await salesService.getCampaign();

        if (response.status >= 400 && response?.status !== 401) {
          setLoadingCampaign(false);
          setDataCampaign([]);
          console.log("status 400", response);
          return;
        }
        if (response.status === 401) {
          setLoadingCampaign(false);
          setIsUnauthorized(true);
          setDataCampaign([]);
          return;
        }

        const dataArray: any = Object.values(response);
        setDataCampaign(dataArray);
        setLoadingCampaign(false);
      } catch (error) {
        setLoadingCampaign(false);
        console.log("errorHandleGetEnterprises", error);
      }
    }, []);

    const handleGetProffesion = useCallback(async () => {
      setLoadingProfession(true);
      try {
        const response = await oportunityServiceInstance.getProfission();

        if (response.status >= 400 && response?.status !== 401) {
          setLoadingProfession(false);
          setDataProfession([]);
          console.log("status 400", response);
          return;
        }
        if (response.status === 401) {
          setLoadingProfession(false);
          setIsUnauthorized(true);
          setDataProfession([]);
          return;
        }

        const dataArray: any = Object.values(response);
        setDataProfession(dataArray);
        setLoadingProfession(false);
      } catch (error) {
        setLoadingProfession(false);
        console.log("errorHandleGetProffesion", error);
      }
    }, []);

    // useMemo: recalcula o nome apenas quando o campo nameAccount muda, ao invés de recalcular em todo render
    const filteredNameParts = useMemo(() => {
      const nameParts =
        formik.getFieldProps("nameAccount").value?.split(" ") ?? [];
      return nameParts.filter((part: string) => part?.trim() !== "");
    }, [formik.values.nameAccount]);

    // useMemo: calcula o flag de campos obrigatórios apenas quando as dependências relevantes mudam (evita recálculo a cada render)
    const isRequirementMet = useMemo(() => {
      const mainPhone = formik.getFieldProps("mainPhone").value;
      const mainEmail = formik.getFieldProps("mainEmail").value;
      const complementaryEmail =
        formik.getFieldProps("complementaryEmail").value;
      const nameAccount = formik.getFieldProps("nameAccount").value;

      const nameInvalid =
        !nameAccount ||
        /\d/.test(nameAccount) ||
        /[^a-zA-ZÀ-ÖØ-öø-ÿ\s]/.test(nameAccount) ||
        (filteredNameParts?.length ?? 0) < 2;

      const marriedStatusNotFilled =
        civilStatus === "Casado(a)" && (!marriageRegime || !weddingDate);

      const phoneInvalid =
        !phoneMask(mainPhone) || phoneMask(mainPhone)?.length < 15;

      const emailInvalid = !mainEmail || (!isEmail(mainEmail) && mainEmail);

      const complementaryEmailInvalid =
        !isEmail(complementaryEmail) && complementaryEmail;

      const baseRequirements =
        nameInvalid ||
        !commercialRegional ||
        !businessUnity ||
        marriedStatusNotFilled ||
        phoneInvalid ||
        emailInvalid ||
        complementaryEmailInvalid;

      if (isCreateAccount) {
        return baseRequirements;
      }

      return baseRequirements || !originAccount;
    }, [
      formik.values.nameAccount,
      formik.values.mainPhone,
      formik.values.mainEmail,
      formik.values.complementaryEmail,
      filteredNameParts,
      commercialRegional,
      businessUnity,
      civilStatus,
      marriageRegime,
      weddingDate,
      originAccount,
      isCreateAccount,
    ]);

    // useEffect agora apenas sincroniza o resultado já calculado pelo useMemo
    useEffect(() => {
      setRequire(isRequirementMet);
    }, [isRequirementMet]);

    return (
      <>
        <Alert
          onOpen={isUnauthorized}
          title="Sessão expirada"
          titleButton={"Fazer login novamente"}
          description={
            "Sua sessão expirou, faça login novamente para ter acesso."
          }
          onClick={() => {
            signOut();
          }}
        />

        {!isCreateAccount && (
          <Styled.ContainerTitlePage>
            <Styled.ContainerTitle>
              <Styled.TitlePage>Contas</Styled.TitlePage>
            </Styled.ContainerTitle>
          </Styled.ContainerTitlePage>
        )}

        <Styled.ContainerBoxAccounts isRelationship={isCreateAccount}>
          {!isCreateAccount && (
            <Styled.ContainerTitleBox>
              <Styled.ContainerTitleWithCloseButton>
                <span>Nova Conta: Cliente - Pessoa Física</span>
              </Styled.ContainerTitleWithCloseButton>
              <Styled.IconAiOutlineCloseCircle onClick={onBack} />
            </Styled.ContainerTitleBox>
          )}

          <Styled.ContainerBoxInfo>
            <SectionMainInformations
              setIdCampaign={setIdCampaign}
              formik={formik}
              error={error}
              setError={setError}
              originAccount={originAccount}
              setOriginAccount={setOriginAccount}
              treatment={treatment}
              setTreatment={setTreatment}
              regional={regional}
              commercialRegional={commercialRegional}
              setCommercialRegional={setCommercialRegional}
              selectedCheckBox={selectedValues}
              setSelectedCheckBox={setSelectedValues}
              businessUnity={businessUnity}
              setBusinessUnity={setBusinessUnity}
              income={income}
              setIncome={setIncome}
              campaign={campaign}
              setCampaign={setCampaign}
              selectCampaign={selectCampaign}
              setSelectCampaign={setSelectCampaign}
              loadingCampaign={loadingCampaign}
              bestHours={bestHours}
              setBestHours={setBestHours}
              purposePurchase={purposePurchase}
              setPurposePurchase={setPurposePurchase}
              detailsLive={detailsLive}
              setDetailsLive={setDetailsLive}
              typeWork={typeWork}
              setTypeWork={setTypeWork}
              numberKids={numberKids}
              setNumberKids={setNumberKids}
              dataCampaign={dataCampaign}
              getCampaign={handleGetCampaign}
              civilStatus={civilStatus}
              setCivilStatus={setCivilStatus}
              dateBirth={dateBirth}
              setDateBirth={setDateBirth}
              dateIssue={dateIssue}
              setDateIssue={setDateIssue}
              nationality={nationality}
              setNationality={setNationality}
              profession={profession}
              setProfession={setProfession}
              selectProfession={selectProfession}
              setSelectProfession={setSelectProfession}
              getProfession={handleGetProffesion}
              loadingProfession={loadingProfession}
              dataProfession={dataProfession}
              setIdProfession={setIdProfession}
              isCreateAccount={isCreateAccount}
              sex={sex}
              setSex={setSex}
              marriageRegime={marriageRegime}
              setMarriageRegime={setMarriageRegime}
              weddingDate={weddingDate}
              setWeddingDate={setWeddingDate}
            />
          </Styled.ContainerBoxInfo>

          {!isCreateAccount && (
            <Styled.ContainerBoxInfo>
              <SectionProductsInterest
                setIdEnterprise={setIdEnterprises}
                selectMainEnterprises={selectMainEnterprises}
                setSelectMainEnterprises={setSelectMainEnterprises}
                mainEnterprises={mainEnterprises}
                setMainEnterprises={setMainEnterprises}
                loadingEnterprises={loadingEnterprises}
                numberRooms={numberRooms}
                setNumberRooms={setNumberRooms}
                numberVacancy={numberVacancy}
                setNumberVacancy={setNumberVacancy}
                dataEnterprises={dataEnterprises}
                getEnterprises={handleGetEnterprises}
              />
            </Styled.ContainerBoxInfo>
          )}

          <Styled.DividerBoxInput />
          <Styled.ContainerFooterBox>
            <Styled.ContainerMandatory>
              <span>(*) Campo de preenchimento obrigatório</span>
            </Styled.ContainerMandatory>
            <Styled.ContainerButton>
              <Button error title="CANCELAR" onClick={onBack} />
              <Button
                title={loading ? <Spinner /> : "CRIAR CONTA"}
                onClick={formik.handleSubmit}
                disabled={require || loading || error.email || error.telefone}
              />
            </Styled.ContainerButton>
          </Styled.ContainerFooterBox>
        </Styled.ContainerBoxAccounts>
      </>
    );
  },
);

export default React.memo(AccountsPhysicalComponents);
